export default __webpack_public_path__ + "8bac89a9968f1152c45cfc6b6a751ae2.png";